import { useEffect, useMemo, useState } from "react";
import { getStations, getTopics, contentVersion, subscribeManasikContent } from "@/lib/manasikContent";

// Merged built-in + admin-managed Hajj stations / reference topics; re-renders after a refresh.
export function useManasikContent() {
  const [version, setVersion] = useState(contentVersion);
  useEffect(() => subscribeManasikContent(setVersion), []);
  return useMemo(() => ({ stations: getStations(), topics: getTopics(), version }), [version]);
}
